export default "__VITE_ASSET__41a27139__"